// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__bpKU7","error":"InputSecondary_error__3DBvb","disabled":"InputSecondary_disabled__2FThO"};